import React, { useState, useTransition } from 'react'
import {Modal} from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { useAxios } from '../../hooks/useAxios'
import { setSuccess } from '../../redux/flashMessages'
import { ModalFooterLoader } from '../../ui/modals/ModalFooterLoader'
import { useTranslation } from 'react-i18next'
import { useLanguage } from '../../hooks/useLanguage'

export const BugReportModal = ({show,hide,studentId,examId}) => {
  const api = useAxios()
  useLanguage()
  const dispatch = useDispatch()
  const [description,setDescription] = useState()
  const [errors,setErrors] = useState()
  const {t} = useTranslation()
  const [sending,setSending] = useState(false)
  const report = async ()=>{
    
    setSending(true)
    try{
      const response = await api.post('bug',{
        description,
        student_id:studentId,
        exam_id:examId
      })
      dispatch(setSuccess("Thank you for your contribution"))
      onHide()
    }catch(ex){
      setErrors(ex?.response?.data?.errors)
    }finally{
      setSending(false)
    }
  }
  const onHide = ()=>{
    setDescription()
    hide()
    setErrors()
  }
  return (
    <Modal show={show} size="lg" onHide={onHide}>
      <Modal.Header>{t('report_bug')}</Modal.Header>
      <Modal.Body>
        <label>
          {t('please_write_description')}
        </label>
        <textarea rows={5} className='form-control' onChange={(e)=>setDescription(e.target.value)} value={description}></textarea>
        {errors?.description && <div className='text-danger fw-bold'>{errors.description}</div>}
      </Modal.Body>
      <Modal.Footer className='d-flex align-items-center justify-content-between'>
        <div>
          {sending && <ModalFooterLoader />}
        </div>
        <div className='btn btn-group'>
          <button className='btn btn-secondary' onClick={onHide}>Cancel</button>
          <button className='btn btn-primary' onClick={report}>Send</button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
